<template>
    <v-container>
      <v-card class="mx-auto" max-width="700">
        <v-card-title>Create Notification Template</v-card-title>
  
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-textarea
              v-model="template"
              label="Notification Message Template"
              :rules="[v => !!v || 'Template cannot be empty']"
              rows="5"
              :hint="`Use placeholders: {{parent_name}}, {{student_name}}, {{student_id}}`"
            />
          </v-form>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" :disabled="!formValid" @click="saveTemplate">
            Save Template
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        formValid: false,
        template: '',
      };
    },
    mounted(){
        this.FetchTemplates();
    },
    methods: {
      async saveTemplate() {
        if (!this.$refs.form.validate()) return;
  
        try {
          const response = await axios.post('createEditTemplate', {
            message: this.template,
            school_id: localStorage.getItem('user_id'),
          });
  
          if (response.data.status) {
            this.FetchTemplates();
            this.$notify({
              title: 'Saved',
              text: 'Template saved successfully!',
              type: 'success',
            });
            this.template = '';
          } else {
            throw new Error('Failed to save template');
          }
        } catch (error) {
          this.$notify({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      },

      async FetchTemplates() {
        try {
          const response = await axios.get('templateParentArrival', {
            params: { school_id: localStorage.getItem('user_id') },
          });
          this.template = response.data.data.message;
        } catch (error) {
          console.error('Error fetching templates:', error);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    margin-top: 40px;
  }
  </style>
  